//https://stackoverflow.com/questions/10301001/perpendicular-on-a-line-segment-from-a-given-point

import getDistanceBetweenLineAndPoint from './getDistanceBetweenLineAndPoint'

function getSpPoint(A, B, C) {
  var x1 = A.x, y1 = A.y, x2 = B.x, y2 = B.y, x3 = C.x, y3 = C.y;
  var px = x2 - x1, py = y2 - y1, dAB = px * px + py * py;
  var u = ((x3 - x1) * px + (y3 - y1) * py) / dAB;
  var x = x1 + u * px, y = y1 + u * py;
  return { x: x, y: y }; //this is D
}

export default function (point, points) {

  let segs = []
    , dists = []
    , minDist = 0
    , hasMinDistSeg
    , i;

  for (i = 0; i < points.length - 1; i++) {
    segs.push([points[i], points[i + 1]])
  }

  for (i = 0; i < segs.length; i++) {
    dists[i] = getDistanceBetweenLineAndPoint(segs[i], point);
    if (i === 0) {
      minDist = dists[i]
    } else {
      minDist = Math.min(dists[i], minDist)
    }
  }

  hasMinDistSeg = segs[dists.indexOf(minDist)];

  if (Math.max(
    Math.abs(hasMinDistSeg[0].x - point.x),
    Math.abs(hasMinDistSeg[0].y - point.y)
  ) < 8) {
    return null;
  }

  if (Math.max(
    Math.abs(hasMinDistSeg[1].x - point.x),
    Math.abs(hasMinDistSeg[1].y - point.y)
  ) < 8) {
    return null;
  }

  let p = getSpPoint(hasMinDistSeg[0], hasMinDistSeg[1], point);

  return {
    x: p.x,
    y: p.y,
    i: dists.indexOf(minDist)
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/utils/getProjectionofPointOnLine.js